import React from "react"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { CompanySettingsForm } from "./CompanySettingsForm"
import { useCompanySettings } from "./useCompanySettings"
import { Spinner } from "@/components/ui/spinner"
import { Building2 } from "lucide-react"

export function CompanySettingsCard() {
  const { isLoading, getFormDefaultValues, saveSettings } = useCompanySettings()
  
  return (
    <Card className="shadow-sm border-border/50">
      <CardHeader className="pb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Building2 className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h2 className="text-xl font-semibold">Organization Settings</h2>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        {isLoading ? (
          <div className="flex items-center py-8">
            <Spinner className="h-6 w-6" />
            <span className="ml-3 text-muted-foreground font-medium">Loading settings...</span>
          </div>
        ) : (
          <CompanySettingsForm 
            defaultValues={getFormDefaultValues()}
            isLoading={isLoading}
            onSubmit={saveSettings}
          />
        )}
      </CardContent>
    </Card>
  )
}
